export default [
  {
    path: 'support-tickets',
    name: 'supportTickets',
    component: () =>
      import(
        /* webpackChunkName: "support-token-list" */ '../pages/supportTicket/SupportTicket.vue'
      ),
    meta: {
      title: 'Support Tokens',
    },
  },
  {
    path: 'support/tickets',
    name: 'supportTicketInbox',
    component: () =>
      import(
        /* webpackChunkName: "support-ticket-inbox" */ '../pages/supportTicket/SupportTicketInboxView.vue'
      ),
    meta: {
      title: 'Support Tickets',
    },
  },
]
